import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-admin-department-form',
    templateUrl: './department-form.component.html',
    standalone: false
})
export class DepartmentFormComponent {
  @Input() public form: any = null;
  @Input() public section: string;
  @Input() public type: string;
}
